import { useQuery } from "@tanstack/react-query";
import { useLanguage } from "@web/lib/contexts/language-context";
import { getSecurityItems } from "../security-items";

export const useSecurityItems = ({ productName }: { productName?: string }) => {
	const { language } = useLanguage();
	const {
		data: securityItems,
		isLoading,
		isError,
		error,
	} = useQuery({
		queryKey: ["security-items", productName, language],
		queryFn: () => getSecurityItems({ productName }),
	});

	return {
		securityItems,
		isLoading,
		isError,
		error,
	};
};
